import { FC } from 'react';

// Components
import { DropdownV2 } from '@velinsi/smp-widgets-ui';
import StatisticRow from './StatisticRow';

interface Props {
  title: string;
  rows: { name: string; value: string }[];
  rowsNumber: number;
  currentSeason?: string;
  seasons: { label: string; value: string }[];
  handleSeasonChange: (value: string) => void;
}

const StatisticRowsList: FC<Props> = ({ title, rows, rowsNumber, currentSeason, seasons, handleSeasonChange }) => {
  return (
    <div className='stats-rows-container'>
      <div className='stats-rows-header flex w-full justify-between gap-2 sm:gap-0 flex-col sm:flex-row items-stretch sm:items-center'>
        <p className='stats-rows-header-title m-0 font-bold text-5 text-hiContrast text-ellipsis overflow-hidden whitespace-pre text-start'>
          {title}
        </p>
        <div className='stats-rows-header-dropdown'>
          <DropdownV2 value={currentSeason} options={seasons} onChange={handleSeasonChange} />
        </div>
      </div>
      <div className='stats-rows-list grid grid-cols-[repeat(auto-fit,minmax(120px,1fr))] py-5 gap-2 sm:gap-4'>
        {rows.map((option, index) => {
          const isLastRow = rowsNumber % 2 === 1 && rows.length - 1 === index;
          return <StatisticRow key={index} {...option} isLastRow={isLastRow} />;
        })}
      </div>
    </div>
  );
};

export default StatisticRowsList;
